import { io, Socket } from "socket.io-client";

let socket: Socket;
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const getSocket = (token?: string | null) => {
  if (!socket) {
    socket = io(`${SOCKET_URL}`, {
      autoConnect: false,
      // path: "/",
      // transports: ["websocket"],

      // withCredentials: true,
      // auth: {
      //   token,
      // },
      query: {
        token,
      },
    });
  } else if (token) {
    // socket.auth = { token };
    socket.io.opts.query = { token };
  }
  return socket;
};